/**
 * API base URL for backend and images.
 *
 * - Development: REACT_APP_API_URL or http://localhost:4000 (proxy handles /api).
 * - Production: empty string = same-origin relative URLs (/api/..., /images/...).
 *   One build works on any domain; Nginx proxies /api and /images to the Node app.
 */
const isProduction = process.env.NODE_ENV === 'production';
const explicit = process.env.REACT_APP_API_URL?.trim();

const API_BASE_URL = isProduction
  ? (explicit || '')
  : (explicit || 'http://localhost:4000');

export { API_BASE_URL };
